// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2rdOp","title":"Images90_title__2dcNd","images":"Images90_images__2ZCsw"};